import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashCollectionSearchResponse from "../CashCollectionSearchResponse";
import ModelProxyClass from "./ModelProxyClass";
import CashCollection from "../CashCollection";


/**
 * @class CashCollectionSearchResponseBase
 * @extends ModelBaseClass
 * @property {[CashCollection]} cashCollections
 * @property {number} totalItemCount (int64)
 */
class CashCollectionSearchResponseBase extends ModelBaseClass {
	/**
	 * @type {[CashCollection]} cashCollections
	 */
	cashCollections;
	/**
	 * @type {number} totalItemCount (int64)
	 */
	totalItemCount;

	/**
	 * Instantiates a new instance of CashCollectionSearchResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashCollectionSearchResponse}
	 */
	static create(genericObject) {
		const newCashCollectionSearchResponse = new CashCollectionSearchResponse();
		newCashCollectionSearchResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashCollectionSearchResponse;
	}

	/**
	 * Instantiates a new array of CashCollectionSearchResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashCollectionSearchResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashCollectionSearchResponseArray = [];
		genericArray.forEach(genericObject => {
			newCashCollectionSearchResponseArray.push(CashCollectionSearchResponse.create(genericObject));
		});
		return newCashCollectionSearchResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('cashCollections', '[CashCollection]'),
	ModelBaseClass.createModelProperty('totalItemCount', 'integer'),
];

export default CashCollectionSearchResponseBase;
